module.exports = __webpack_public_path__ + "static/media/sql.8740d966.png";